import { render } from "./App.vue?vue&type=template&id=64bc222e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=64bc222e&lang=scss"

import exportComponent from "D:\\Development\\JS\\SeptaCode\\septacode.com\\demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__